import { useInView } from "react-intersection-observer";
export const useInViews = () => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.5,
    trackVisibility: true,
    triggerOnce: false,
    delay: 1000,
  });
  return {
    ref,
    inView,
  };
};
